module.exports = __webpack_public_path__ + "img/border_garden.f055f805.svg";